import App from "../../../../vendor_core/core/src/App";
import { ConfigurationTypes } from '../../../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../../../vendor_core/core/src/managers/ConfigManager';
import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import { BonusPositionTypes } from "../../../../vendor_core/core/src/server/data/BonusPositionTypes";
import { IBonusData } from "../../../../vendor_core/core/src/server/data/ICustomData";
import ISpinData, { IOverlayData, ISpinificationData, ISymbolPosition, IWinData, OverlayType } from "../../../../vendor_core/core/src/server/data/ISpinData";
import Utils from "../../../../vendor_core/core/src/utils/Utils";
import { IVendorLineData, IVendorSpinData } from "../../../../vendor_core/src/model/IVendorSpinData";
import IFantasmaConfig from '../../../../vendor_core/src/server/data/IFantasmaConfig';
import SpinDataParser from "../../../../vendor_core/src/server/parsers/SpinDataParser";


export default class SaSSpinDataParser extends SpinDataParser {

    /**
     * Defines whether the server data is one based or zero based.
     *
     * @private
     * @memberof SaSSpinDataParser
     */
    private indexBase: number = 1;
    private freespinsNames: string[] = ["freespinsBN1", "freespinsBN2"];
    private blackHoleSymId: number = 14;

    protected processData(data): ISpinData[] | ISpinData {
        let featureMode: number = -1;
        if (data.freespinsBN1 || data.refresh?.freespinsBN1) {
            data.freespins = data.freespinsBN1 || data.refresh?.freespinsBN1;
            featureMode = 1;
        }
        if (data.freespinsBN2 || data.refresh?.freespinsBN2) {
            data.freespins = data.freespinsBN2 || data.refresh?.freespinsBN2;
            featureMode = 2;
        }
        if (data.refresh && data.refresh.restoreState == undefined) {
            featureMode = -1;
        }
        const results = super.processData(data);

        if (Array.isArray(results)) {
            results.forEach((result) => {
                result.featureMode = featureMode;
            })
        } else {
            results.featureMode = featureMode;
        }

        return results;
    }

    public parse(data: any): ISpinData | ISpinData[] {
        if (data && data.refresh == undefined && data.mainSpin == undefined) {
            // This means we are using the proto server, which is 0 based.
            this.indexBase = 0;
            data.mainSpin = Utils.deepClone(data);
            data.freespins?.forEach(fs => {
                fs.mainSpin = {};
                fs.mainSpin.symbols = fs.symbols;
                fs.mainSpin.expandFeature = fs.expandFeature;
            })
        }

        return super.parse(data);
    }

    protected parseFreespins(spinData:IVendorSpinData, result: ISpinData, results: ISpinData[]) {
        let fsData;
        this.freespinsNames.forEach((name) => {
            if (spinData[name] != undefined) {
                fsData = spinData[name];
            }
        });

        if(fsData) {
            if (fsData.length) {
                result.freespinsNum = fsData.length;
                result.freespinsWon = fsData.length;
                result.totalFreeSpins = fsData.length;

                fsData.forEach((fsObj, index) => {
                    let duplicate: IVendorSpinData = Utils.deepClone(spinData);
                    duplicate.mainSpin = fsObj;
                    let fSpin = this.parseSlotObject(duplicate, true, result.winAmount, Utils.deepClone(results));
                    fSpin.freespinsNum = fsData.length - index - 1;
                    fSpin.winsMultiplier = fsObj.persistentMultiplier || 1;
                    results.push(fSpin);
                })
            }
        } else {
            // If the game has a pick screen, the first response is not there a freespins object
            // and we have to check it as counting the scatters
            SpinModel.freespinsNum = 0;
            SpinModel.totalFreeSpins = 0;
            result.freespinsWon = (this.freespinCheck(spinData))?1:0;
        }
    }

    protected freespinCheck(data: any): boolean {
        let symbols = data.mainSpin ? data.mainSpin.symbols : data.jackpotTriggeringSpin.symbols
        let bonusCount = 0;
        const spinifyReels = GameModel.gameConfig.spinifyReels;
        const spinifySymIds = GameModel.gameConfig.spinifySymIds;
        const symMap = GameModel.gameConfig.symbolResponseMap;
        for (
            let i = spinifyReels[0];
            i <= spinifyReels[spinifyReels.length - 1];
            i++) {
            if (symbols[i].find((sym) => {
                let symModifyName = sym;
                return (spinifySymIds.indexOf(symMap[symModifyName].id) != -1);
            })) {
                bonusCount++;
            }
        }

        return bonusCount == spinifyReels.length;
    }

    parseOverlays(
        result: ISpinData,
        spinD: IVendorSpinData,
        previousSpins?: ISpinData[]
    ): IOverlayData[] {
        /*if(!spinData[this.freespinsNames[0]] && (!spinData.expand || !spinData.expand.length)) {
            return [];
        }*/
        let spinData = spinD.mainSpin
            ? spinD.mainSpin
            : spinD
        let array = new Array<IOverlayData>();
        let symbolPositions = new Array<Array<number>>();
        let overlayType: OverlayType;

        for (let i = 0; i < result.reelFinalSymbols.length; i++) {
            const reel = result.reelFinalSymbols[i];
            let array = new Array<number>();
            for (let j = 0; j < reel.length; j++) {
                const symbol = reel[j];
                array.push(null);
            }
            symbolPositions.push(array);
        }
        let initPositions: ISymbolPosition[] = [];

        if (spinData.expand && spinData.expand.length) {
            overlayType = OverlayType.Expanding;

            spinData.expand.forEach((obj) => {
                const sym = spinData.symbols[obj.origin.x - this.indexBase][obj.origin.y - this.indexBase];

                this.markExpandedSymbols(symbolPositions, obj);

                let newPos: ISymbolPosition = {"reel": obj.origin.x - this.indexBase, "row": obj.origin.y - this.indexBase};
                initPositions.push(newPos);
            });
        } else if (spinData.stickyWilds) {
            overlayType = OverlayType.Locked;

            spinData.stickyWilds.forEach((wildObj) => {
                symbolPositions[wildObj.x - this.indexBase][wildObj.y - this.indexBase] = 1;
            });
        }

        if(overlayType == undefined) {
            return [];
        }

        let overlay: IOverlayData = {
            type: overlayType,
            symbolPosition: symbolPositions,
            initPositions: initPositions
        };

        array.push(overlay);
        return array;
    }

    private markExpandedSymbols(symbolPositions, expandObj) {
        let exX = expandObj.origin.x - this.indexBase;
        let exY = expandObj.origin.y - this.indexBase;
        let exDirX = expandObj.direction[0];
        let exDirY = expandObj.direction[1];
        if(exDirX == exDirY && exDirX == 0) {
            exX -= 1;
            exY -= 1;
            exDirX = 2;
            exDirY = 2;
        }
        let stepY = 0;
        let stepX = 0;

        let y = exY;
        for(let i = exY; i <= (exY + Math.abs(exDirY)); i++) {
            let x = exX;
            for(let j = exX; j <= (exX + Math.abs(exDirX)); j++) {
                symbolPositions[x += stepX][y] = this.blackHoleSymId;
                stepX = exDirX > 0? 1 : -1;
            }
            stepY = exDirY > 0? 1 : -1;
            y += stepY;
            stepX = 0;
        }
    }

    getRoundWin(spinData: IVendorSpinData,
        isFree: boolean,
        accumulated: boolean = false): number {
        let win: number = 0;
        let winings = spinData.winnings
            ? spinData.winnings
            : spinData.mainSpin.winnings
        if (isFree) {
            winings?.forEach((winObj) => {
                win += winObj[2];
            });
            if (accumulated) {
                if (App.config.isProtoServer && spinData.persistentMultiplier) {
                    win *= spinData.persistentMultiplier;
                }
                win += (spinData.runningTotal || spinData.mainSpin?.runningTotal) || 0;
            }
        } else {
            if (spinData.win != undefined) {
                if ((spinData["freespinsBN1"] && spinData["freespinsBN1"].length > 0) || (spinData["freespinsBN2"] && spinData["freespinsBN2"].length > 0)) {
                    // In case we have free spins restore (user already selected their amount),
                    // the backend will send the whole win, including free spin wins.
                    // We need to find out the real main spin win amount, because the spindata.mainSpin will equal to 0.
                    // We can get the win from the first free spin, but we need to subtract the fs winnings (if have).
                    winings?.forEach((winObj) => {
                        if (winObj[0] !== "freespins") {
                            win += winObj[2];
                        }
                    });
                } else {
                    win = spinData.win;
                }
            } else {
                // This is a case, where the game supports free spins selection
                // and the server did not compute the total win yet,
                // because the user must first choose how many free spins s/he wants.
                // The code below computes the winnings of the main spin,
                // before the free spins selection.
                winings?.forEach((winObj) => {
                    if (winObj[0] !== "freespins") {
                        win += winObj[2];
                    }
                });
            }
        }

        const result = this.setMaxWinCap(spinData, win);

        return result;
    }

    private setMaxWinCap(spinData: IVendorSpinData, win: number): number {
        let result = win;
        const maxWinCap = ConfigManager.getConfig<IFantasmaConfig>(ConfigurationTypes.GAME)?.maxWinCapMultiplier || 0;
        const bet = spinData?.ba;
        if (maxWinCap && bet && win && win / bet >= maxWinCap) {
            result = bet * maxWinCap;
        }

        return result
    }

    parseBonuses(data: any): IBonusData[] {
        const bonuses = new Array<IBonusData>();

        // Parse the BH symbol multipliers
        let multiplier;
        if (data) {
            multiplier = data.multiplier
                ? data.multiplier
                : data.mainSpin.multiplier
        }

        if (multiplier) {
            multiplier.forEach(item => {
                const x = item.coord.x - this.indexBase;
                const y = item.coord.y - this.indexBase;
                const multi = item.multiplier;
                const multiplierBonus: IBonusData = {
                    symbolId: this.blackHoleSymId,
                    multiplier: multi,
                    type: BonusPositionTypes.SymbolMultiplier,
                    symbolPositions: [{ reel: x, row: y }]
                }

                bonuses.push(multiplierBonus);
            })
        }

        // Parse the BH symbols merge data
        let merged;
        if (data) {
            merged = data.merged
                ? data.merged
                : data.mainSpin.merged
        }
        if (merged) {
            merged.forEach(item => {
                const multi = item.multiplier;
                const positions: ISymbolPosition[] = [];
                item.coords.forEach(coord => {
                    positions.push({ reel: coord.x - this.indexBase, row: coord.y - this.indexBase });
                });

                const mergeData: IBonusData = {
                    symbolId: this.blackHoleSymId,
                    multiplier: multi,
                    type: BonusPositionTypes.SymbolMerge,
                    symbolPositions: positions
                }

                bonuses.push(mergeData);
            })
        }

        // Parse the expand data
        let expand;
        if (data) {
            expand = data.expand
                ? data.expand
                : data.mainSpin.expand
        }
        if (expand) {
            expand.forEach(item => {
                const originX = item.origin.x - this.indexBase;
                const originY = item.origin.y - this.indexBase;
                const directionX = item.direction[0];
                const directionY = item.direction[1];

                const expanding: IBonusData = {
                    symbolId: this.blackHoleSymId,
                    type: BonusPositionTypes.ExpandingSymbol,
                    symbolPositions: [
                        { reel: originX, row: originY },
                        { reel: directionX, row: directionY }
                    ]
                }

                bonuses.push(expanding);
            })
        }

        return bonuses;
    }

    // We need to subtract 1
    parseLine(line: IVendorLineData): IWinData {
        let win: IWinData = {
            winSymbols: Array.from(
                new Array(line[3].length),
                (e, i) => {
                    return line[3][i].y - 1; // TODO: check this at the base class.
                }
            ),
            winReels: Array.from(
                new Array(line[3].length),
                (e, i) => {
                    return line[3][i].x - 1;
                }
            ),
            winSymId: GameModel.gameConfig.symbolResponseMap[line[4]].id,
            isWay: !(
                GameModel.serverGameConfig?.paylines &&
                GameModel.serverGameConfig.paylines.length > 0
            ), //TODO
            lineId: line[1] - 1,
            normalLineWin: (line[0] == "normal") ? true : false,
            creditsWon: line[2],
        };
        let winSymId = GameModel.gameConfig.symbolResponseMap[line[4]].id
        win.coordinates = line[3].map((pos, index) => {
            return { x: pos.x - 1, y: pos.y - 1 };
        });

        return win;
    }

    parseSpinification(result: ISpinData): ISpinificationData {
        let spinification: ISpinificationData = {
            spinificationIndex: result.reelFinalSymbols.length,
            spinificationEndIndex: result.reelFinalSymbols.length,
        };
        let spinifyCount = new Map<number, number>();

        result.reelFinalSymbols.forEach((reel, reelId) => {
            reel.forEach((sym, rowId) => {
                if (GameModel.gameConfig.spinifySymIds?.indexOf(sym) != -1) {
                    if (!spinifyCount.has(sym)) {
                        spinifyCount.set(sym, 0);
                    }
                    spinifyCount.set(sym, spinifyCount.get(sym) + 1);
                    
                    if (
                        spinifyCount.get(sym) ===
                        GameModel.gameConfig.spinifyNumSymsNeeded[sym] &&
                        GameModel.gameConfig.spinifyReels.indexOf(reelId + 1) != -1
                    ) {
                        if (
                            !spinification.spinificationIndex ||
                            spinification.spinificationIndex > reelId + 1
                        ) {
                            spinification.spinificationIndex = reelId + 1;
                            spinification.spinificationSymbolId = sym;
                        }
                    }
                    if (spinifyCount.get(sym) > GameModel.gameConfig.spinifyNumSymsNeeded[sym]) {
                        spinification.spinificationEndIndex = reelId;
                    }
                }
            });
        });

        return spinification;
    }
}
